import React from 'react'
import styles from './school.styles'
import injectSheet from 'react-jss'
import classNames from 'classnames'

const School = ({ classes, title, address, id, onClick, selected }) => (
  <div
    className={classNames(
      classes.container,
      { [classes.selected]: selected },
      'metrics__select-school'
    )}
    onClick={onClick}>
    <p className={classes.title}>{title}</p>
    <p className={classes.address}>{address}</p>
  </div>
)

export default injectSheet(styles)(School)
